import { ReactElement } from 'react';
import { MenuItem, Select, TextField, styled } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip, ValueLabel, triggerStyles } from '../common';
import config from '../config.json';
import { pathOr } from 'rambda';
import { map as lmap } from 'lodash/fp';

export function Justification({
  value,
  options,
  onChange,
  otherComments,
  onChangeOtherComments,
  tooltipValue,
  toggleTooltip,
  offTooltip,
}: {
  value: string;
  options: ValueLabel<string>[];
  onChange: (value: string) => void;
  otherComments: string | null;
  onChangeOtherComments: (value: string) => void;
  tooltipValue: (name: string) => boolean;
  toggleTooltip: (name: string) => void;
  offTooltip: (name: string) => void;
}) {
  return (
    <>
      {options.length > 0 && (
        <>
          <RevokeJustificationLabel id="request-justification">
            Justification <span className="danger text-1-dot-2">*</span> :
          </RevokeJustificationLabel>
          <Tooltip name="requestJustification" tooltipValue={tooltipValue}>
            <RevokeJustificationSelect
              labelId="request-justification"
              value={value}
              onChange={({ target: { value } }) => onChange(value as string)}
              variant="outlined">
              {lmap<ValueLabel<string>, ReactElement>(({ value, label }) => (
                <MenuItem value={value} key={value}>
                  {label}
                </MenuItem>
              ))(options)}
            </RevokeJustificationSelect>
          </Tooltip>
          <RevokeJustificationTooltipTrigger
            name="requestJustification"
            toggleTooltip={toggleTooltip}
            offTooltip={offTooltip}
          />
        </>
      )}

      {options.length === 0 && (
        <>
          <CommentsLabel htmlFor={`request-comments`}>Comments :</CommentsLabel>

          <CommentsInput
            id={`request-comments`}
            value={value}
            onChange={({ target: { value } }) => onChange(value)}
            variant="outlined"
          />
        </>
      )}

      {value === 'Other' && (
        <>
          <CommentsLabel htmlFor={`request-comments`}>Comments :</CommentsLabel>

          <CommentsInput
            id={`request-comments`}
            value={otherComments}
            onChange={({ target: { value } }) => onChangeOtherComments(value)}
            variant="outlined"
          />
        </>
      )}
    </>
  );
}

const CommentsLabel = styled('label')(({ theme }) => ({
  '@media (min-width: 33.375em)': {
    gridRowStart: 5,
    justifySelf: 'end',
  },
}));

const CommentsInput = styled(TextField)(({ theme }) => ({
  '@media (min-width: 33.375em)': {
    gridRowStart: 5,
    gridColumnStart: 2,
    gridColumnEnd: 6,
  },
}));

const RevokeJustificationLabel = styled('label')(({ theme }) => ({
  '@media (min-width: 33.375em)': {
    gridRowStart: 2,
    justifySelf: 'end',
  },
}));

const RevokeJustificationSelect = styled(Select)(({ theme }) => ({
  '@media (min-width: 33.375em)': {
    gridRowStart: 2,
    gridColumn: '2/5',
  },
}));

const RevokeJustificationTooltipTrigger = ({
  name,
  toggleTooltip,
  offTooltip,
}: {
  name: string;
  toggleTooltip: (tooltip: string) => void;
  offTooltip: (tooltip: string) => void;
}) => (
  <TWrapper
    onClick={() => toggleTooltip(name)}
    onBlur={() => offTooltip(name)}
    aria-label={pathOr('idk', name)(config)}
    type="button">
    <FontAwesomeIcon icon={faInfoCircle} size="1x" fixedWidth />
  </TWrapper>
);

const TWrapper = styled('button')(({ theme }) => ({
  ...triggerStyles,

  '@media (min-width: 33.375em)': {
    gridRowStart: 2,
    gridColumn: '5/6',
  },
}));
